<template>
  <div class="userlist-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/05/liebiao_icon.png"
           alt="">
      用户列表
    </div>
    <el-form ref="form"
             :model="form"
             class="userlist_search"
             :inline="true">
      <el-form-item label="角色类型">
        <el-select v-model="form.region"
                   placeholder="请选择角色类型"
                   size="small">
          <el-option label="货主公司"
                     value="0"></el-option>
          <el-option label="物流公司"
                     value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input v-model="form.name"
                  size="small"
                  placeholder="请输入联系人姓名"></el-input>
      </el-form-item>
      <el-form-item label="公司名称">
        <el-autocomplete class="inline-input permission_search"
                         size='small'
                         v-model="inputName"
                         :fetch-suggestions="querySearch"
                         placeholder="请输入公司名称"
                         :trigger-on-focus="false">
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="账号">
        <el-input v-model="form.registrarNumber"
                  size="small"
                  placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item class="btn_box">
        <el-button type="primary"
                   size="small"
                   class="search_btn"
                   @click="handleSearchClick">查询</el-button>
        <router-link to="userlist/adduserlist">
          <el-button type="warning"
                     size="small"
                     class="add_btn">添加</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="userlsit_table">
      <el-table :data="userData.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         fixed
                         label="序号"
                         align="center"
                         type="index"
                         width="50">
        </el-table-column>
        <el-table-column label="角色类型">
          <template slot-scope="scope">
            <div v-if="scope.row.userType === '0'">货主公司</div>
            <div v-else-if="scope.row.userType === '1'">物流公司</div>
          </template>

        </el-table-column>
        <el-table-column label="公司名称">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.companyName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名">
          <template slot-scope="scope">
            <div>{{scope.row.petname}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="username"
                         label="账号"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column label="用户状态"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.state === '0'">正常</div>
            <div v-else-if="scope.row.state === '1'">禁用</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         prop="time"
                         label="注册时间"
                         min-width="100"
                         align="center"></el-table-column>
        <el-table-column label="备注"
                         prop="remarks"
                         header-align="center"
                         align="center"
                         width="100"></el-table-column>
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.userId )"></el-button>
            </el-tooltip>
            <el-tooltip class="item unblocked"
                        effect="dark"
                        content="禁用"
                        placement="top"
                        v-if="scope.row.state === '0'">
              <el-button @click="handleDisabledClick(scope.row.userId,scope.row.state )"></el-button>
            </el-tooltip>
            <el-tooltip class="item unblocked"
                        effect="dark"
                        content="解禁"
                        placement="top"
                        v-else-if="scope.row.state === '1'">
              <el-button @click="handleDisabledClick(scope.row.userId,scope.row.state )"></el-button>
            </el-tooltip>
            <el-tooltip class="item record"
                        effect="dark"
                        content="登记记录"
                        placement="top">
              <el-button @click="handleRekodClick(scope.row.userId )"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="登记记录"
               :visible.sync="showDetails"
               class="biddingTable"
               trigger="click">
      <el-table ref="multipleTable"
                :data="detailList.result"
                tooltip-effect="dark"
                style="width: 100%"
                max-height="491">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40">
        </el-table-column>

        <el-table-column label="设备ID"
                         align="left"
                         header-align="center">
          <template slot-scope="scope">{{scope.row.deviceId}}</template>
        </el-table-column>
        <el-table-column label="设备名称"
                         align="center"
                         header-align="center"
                         prop="deviceModel">
        </el-table-column>
        <el-table-column label="系统版本"
                         prop="deviceOs"
                         align="center"
                         header-align="center">
        </el-table-column>
        <el-table-column label="登录IP"
                         prop="ip"
                         align="center"
                         header-align="center">
        </el-table-column>
        <el-table-column label="时间"
                         align="center"
                         prop="time"
                         header-align="center">
        </el-table-column>
      </el-table>
      <div class="pages">
        <span class="demonstartion"> 共{{detailList.total}}条记录</span>
        <el-pagination @current-change="handledetailChange"
                       :page-size="detailList.pageSize"
                       layout="prev, pager, next"
                       :total="detailList.total"
                       background>
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{userData.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="userData.pageSize"
                     layout="prev, pager, next"
                     :total="userData.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { userList, userListChange, allCompanyList, rekodBancian } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      form: {
        name: '', // 联系人姓名
        region: '', // 下拉菜单
        // companyName: '', // 公司名称
        registrarNumber: ''// 注册号码
      },
      userData: [],
      companyList: [],
      inputName: '',
      showDetails: false,
      detailList: [],
      detailId: '',
      type: 2,
      pageNum: 1,
      companyId: ''
    }
  },
  mounted () {
    this.getUserList()
    this.getAllCompany()
  },
  methods: {
    getUserList () { // 获取用户列表
      userList({
        pageNum: this.pageNum,
        companyId: this.companyId,
        userType: this.form.region,
        username: this.form.registrarNumber,
        petname: this.form.name

      }).then(res => {
        if (res.data.code === 0) {
          this.userData = res.data.data.result
        }
      })
    },
    handleDisabledClick (id, state) { // 禁用、解禁用户列表
      let status = state === '0' ? '1' : '0'
      userListChange({
        type: '1',
        userId: id,
        state: status
      }).then(res => {
        if (res.data.code === 0) {
          this.getUserList()
        }
      })
    },
    querySearch (queryString, cb) { // 模糊查询
      var csvS = this.csvS
      cb(csvS)
    },
    createFilter (queryString) { // 模糊查询
      return (companyList) => {
        return (companyList.companyName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSearchClick () { // 查询
      let itemId = ''
      // console.log(this.inputName)
      this.companyList.forEach(res => {
        if (res.companyName === this.inputName) {
          itemId = res.companyId
        }
      })
      this.companyId = itemId
      this.getUserList()
    },
    getAllCompany () { // 初始化获取所有公司列表
      allCompanyList({
        type: this.type
      }).then(res => {
        if (res.data.code === 0) {
          this.companyList = res.data.data.result
        }
      })
    },
    handleCurrentChange (val) { // 切页切换
      this.pageNum = val
      this.getUserList()
    },

    handleUpdateClick (id) { // 修改
      // console.log(id)
      this.$router.push({ path: 'userlist/adduserlist', query: { item: id } })
      // userListDetail({
      //   userId: id
      // }).then(res => {
      //   if (res.data.code === 0) {
      //     // console.log('test', res)
      //     this.$store.commit('userlist/showAddUserlist', true)
      //     const userlistInfo = res.data.data.result
      //     this.$store.commit('userlist/updateUserlist', userlistInfo)
      //   }
      // })
    },
    handleRekodClick (id) { // 登记记录
      this.showDetails = true
      this.detailId = id
      rekodBancian({
        userId: id
      }).then(res => {
        if (res.data.code === 0) {
          // console.log(res)
          this.detailList = res.data.data.result
        }
      })
    },
    handledetailChange (val) {
      rekodBancian({
        userId: this.detailId,
        pageNum: val
      }).then(res => {
        this.detailList = res.data.data.result
      })
    }
  },
  watch: {
    inputName: function () { // 模糊查询
      this.csvS = []
      var len = this.companyList.length
      var arr = []
      for (var i = 0; i < len; i++) {
        if (this.companyList[i].companyName.indexOf(this.inputName) >= 0) {
          arr.push(this.companyList[i])
        }
      }
      // el-autocomplete元素要求数组内是对象，且有value属性
      for (var j = 0; j < arr.length; j++) {
        var obj = { value: '' }
        obj.value = arr[j].companyName
        this.csvS.push(obj)
      }
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
@media (max-width: 1440px)
  .userlsit_table
    height calc(100% - 210px) !important
.userlist-container
  height 100%
  padding 20px
  min-width 978px
  .title
    background #FFFFFF
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    .title_img
      background #9231ff
      margin-left 20px
      margin-right 10px
      border-radius 50%
  .userlist_search
    background #FFFFFF
    overflow hidden
    padding-right 180px
    // overflow hidden
    position relative
    padding-left 10px
    // height 40px
    // padding-top 10px
    .el-form-item
      margin-bottom 5px
      float left
    .btn_box
      position absolute
      top 0
      right 20px
      .search_btn
        searchBtn()
        margin-left 22px
        margin-right 20px
      .add_btn
        addBtn()
    .el-input
      width 150px
      margin-right 28px
  .userlsit_table
    height calc(100% - 170px)
    .el-table__body-wrapper
      background #f7f9fb
    .el-table
      .cell
        height 56px
        line-height 18px
        size12()
        .el-button
          padding 6px 14px
          width 28px
          cursor pointer
          height 28px
          margin 0 8px
          &.update
            update()
          &.unblocked
            unblocked()
          &.delete
            delete()
          &.record
            record()
    .el-table th
      background #e7f0f8
      .cell
        height 25px
        line-height 25px
  .biddingTable
    .el-dialog
      width auto
      width 900px
      .el-dialog__header
        height 42px
        padding 0 20px 0
        background #1b88ee
        .el-dialog__title
          line-height 42px
          font-size 13px
          color #fff
          float left
        .el-dialog__headerbtn
          top 12px
          right 12px
          .el-dialog__close
            color #fff
            font-size 20px
      .el-dialog__body
        padding 15px 20px
        .companySelect
          width 180px
          height 30px
          margin 0
          float left
          margin-bottom 20px
          .el-input__inner
            width 145px
            height 30px
          .el-input-group__append
            padding 0
            .el-button
              margin 0
            .el-button--mini, .el-button--mini.is-round
              padding 7px 12px
        .operation
          .el-button
            margin 0
            padding 7px 27px
        .operations
          .el-button
            margin-bottom 0
            padding 7px 27px
        .permission_search
          float left
          margin-bottom 20px
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
